import type { PaymentType } from './types';

export const PAYMENT_TYPE_BY_TYPENAME = {
	PaymentMethodCreditCard: 'creditCard',
	PaymentMethodPayPal: 'paypal',
	PaymentMethodSepa: 'sepa',
	// TODO: remove once the remaining active Venmo subscriptions are retired. 'venmo' is not a real
	// PaymentType, so it widens the value type here and the cast below papers over that until then.
	PaymentMethodVenmo: 'venmo',
	PaymentMethodLink: 'link',
} satisfies Record<string, PaymentType | 'venmo'>;

export type KnownSavedPaymentMethodTypename = keyof typeof PAYMENT_TYPE_BY_TYPENAME;

export function paymentTypeFromTypename(typename: KnownSavedPaymentMethodTypename): PaymentType {
	return PAYMENT_TYPE_BY_TYPENAME[typename] as PaymentType;
}
